import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var TransactionLogSvg = function TransactionLogSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.526 2.249h13.32L22 7.309v14.94h-9.521v-1.395h8.1V7.887l-4.32-4.243H4.946v4.884h-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.72 13.412 1.156 1.134-1.005.987L2 12.714l2.87-2.819 1.006.987-1.156 1.135h4.443v1.395zM9.342 17.598l-1.155-1.135 1.005-.986 2.87 2.819-2.87 2.819-1.005-.987 1.155-1.135H4.9v-1.395zM13.426 8.296H8.69V6.9h4.737zM18.163 12.947H12.48V11.55h5.684zM18.163 17.598h-3.79v-1.395h3.79z"
  }));
};
export var TransactionLog = function TransactionLog(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: TransactionLogSvg
  }));
};